// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppController from "./app_controller"
application.register("app", AppController)

import ToggleController from "./twofactor_controller"
application.register("twofactor", ToggleController)

import InitializeTwoFactor from "./initialize_twofactor_controller"
application.register("initialize-twofactor", InitializeTwoFactor)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import WebauthnSessionFormController from "./webauthn_session_form_controller"
application.register("webauthn-session-form", WebauthnSessionFormController)

import PasskeyController from "./passkey_controller"
application.register("passkey", PasskeyController)

import LoginController from "./login_controller"
application.register("login", LoginController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)